import { clearMessage } from "../../../Actions";
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

class UserMessage extends Component {
  messageFunction = () => {
    return (
      this.props.message.length > 0 && (
        <MsgClass>
          {this.props.message.map((msgs, index) => (
            <Message value={this.props.cssClass} key={index}>
              <MsgText>{msgs}</MsgText>
            </Message>
          ))}
        </MsgClass>
      )
    );
  };
  componentDidUpdate(prevprops) {
    if (prevprops.message.length !== this.props.message.length) {
      setTimeout(() => {
        this.props.dispatch(clearMessage([]));
      }, 2000);
    }
  }
  render() {
    return this.messageFunction();
  }
}

const mapStateToProps = ({ userMessage }) => {
  return {
    message: userMessage.payload,
    cssClass: userMessage.cssClass
  };
};

const MsgClass = styled.div`
  position: fixed;
  bottom: 20px;
  background: #fff;
  padding: 20px;
  margin: 0 auto;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  width: 50%;
  left: 30%;
  transition-duration: 500ms;
`;

const MsgText = styled.span`
  position: relative;
  top: 19px;
`;

const Message = styled.div` 
  border-top : ${props =>
    props.value === "SUCCESS" ? "3px solid green" : "3px solid #ff0000"}   
  position: relative;
  bottom: 20px;
  width: 106%;
  right: 20px;
`;

export default connect(mapStateToProps)(UserMessage);
